// extracted by mini-css-extract-plugin
export default {"Controls":"styles_Controls__LGQuW","control":"styles_control__zYTJX","active":"styles_active__cuvYN"};